import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../supabaseClient';

export function LoginPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/contracts');
    }
  }, [user, navigate]);

  const handleSignIn = async () => {
    const toastId = toast.loading('Redirecting to Microsoft login...');

    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'azure',
        options: {
          scopes: 'email openid profile',
          redirectTo: `${window.location.origin}/auth/callback`,
        },
      });
      if (error) throw error;
      toast.dismiss(toastId);
    } catch (error) {
      console.error('Failed to sign in:', error);
      toast.error('Failed to sign in with Azure AD. Please try again.', { id: toastId });
    }
  };

  return (
    <div className="min-h-screen bg-privion-dark text-privion-light flex flex-col">
      {/* Soft brand glow behind the card */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-privion-blue/20 blur-[140px]" />
        <div className="absolute bottom-[-200px] right-[-200px] w-[500px] h-[500px] rounded-full bg-privion-blue/10 blur-[120px]" />
      </div>

      <main className="relative flex-1 flex flex-col items-center justify-center px-6 py-16">
        {/* Privion logo */}
        <img
          src="/brand/privion-logo-tagline-on-dark.svg"
          alt="Privion"
          className="h-16 mb-12 select-none"
          draggable={false}
        />

        {/* Sign-in card */}
        <div className="w-full max-w-md bg-white/[0.04] border border-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-2xl">
          <h1 className="text-2xl font-semibold tracking-tight mb-2">
            Sign in to Privion CLM
          </h1>
          <p className="text-sm text-privion-grey mb-8">
            Contract Lifecycle Management
          </p>

          <button
            onClick={handleSignIn}
            className="w-full flex items-center justify-center gap-3 px-6 py-3.5 bg-privion-blue hover:bg-primary-700 text-white font-medium rounded-lg transition-colors shadow-lg shadow-privion-blue/20"
          >
            <svg className="w-5 h-5" viewBox="0 0 23 23" aria-hidden="true">
              <rect x="0"  y="0"  width="11" height="11" fill="#F25022" />
              <rect x="12" y="0"  width="11" height="11" fill="#7FBA00" />
              <rect x="0"  y="12" width="11" height="11" fill="#00A4EF" />
              <rect x="12" y="12" width="11" height="11" fill="#FFB900" />
            </svg>
            Sign in with Microsoft
          </button>

          <p className="text-center text-xs text-privion-grey mt-6">
            Secured with Microsoft Entra ID
          </p>
        </div>

        <p className="text-sm text-privion-grey mt-8">
          Need help? Contact your system administrator
        </p>
      </main>

      <footer className="relative px-6 py-6 text-center text-xs text-privion-grey/70">
        © 2026 Privion. All rights reserved.
      </footer>
    </div>
  );
}
